import { CreateDocumentFileRequest, createDocumentFile } from 'commons/service/client/documentFile'
import { DocumentFile } from 'commons/types/DTO/client/documentFile'
import { WriteHook, useMutationManager } from 'state-manager'

export const useCreateDocumentPeriodFile: WriteHook<CreateDocumentFileRequest, DocumentFile> = (opts) =>
  useMutationManager<CreateDocumentFileRequest, DocumentFile>(createDocumentFile, opts)
